function productOverviewFormatStyles() {
    /* Wraps tables with a div to make them responsive */
    var tables = document.querySelectorAll('.product-content__details table')
    Array.from(tables).forEach(function (el) {
        var tableRow = el.querySelector('tbody tr')
        var tableRowCells = tableRow.querySelectorAll('td')
        if (
            (tableRowCells.length > 2 && window.innerWidth <= 767) ||
            (tableRowCells.length > 4 && window.innerWidth >= 768)
        ) {
            var newTableHtml =
                '<div class="table-responsive">' + el.outerHTML + '</div>'
            el.outerHTML = newTableHtml
        }
    })
}

export { productOverviewFormatStyles }
